<!--
 * @Descripttion: 
 * @version: v1
 * @Author: liukx
 * @Date: 2022-05-01 23:09:12
 * @LastEditors: ???
 * @LastEditTime: 2022-06-11 14:25:20
-->
<template>
  <div class="wrapper">
    <el-dialog
      :close-on-click-modal="false"
      :title="title"
      :visible.sync="visible"
      width="40%"
      @close="close"
    >
      <el-form
        :model="form"
        ref="form"
        :rules="validatorRules"
        label-width="80px"
        :inline="false"
        size="normal"
      >
        <el-form-item label="预约时间" prop="day">
          <!-- <el-date-picker
            style="width: 400px"
            v-model="form.dateRange"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            value-format="yyyy-MM-dd hh:mm:ss"
            :picker-options="endDateOpt"
          >
          </el-date-picker> -->
          <div class="datePicker">
            <div class="left">
              <ul>
                <li v-for="(item, i) in days" :key="i">
                  <el-radio
                    v-model="form.day"
                    :label="item.date"
                    @change="dayChange(i)"
                    >{{ item.date }} &nbsp;{{ item.week }}</el-radio
                  >
                </li>
              </ul>
            </div>
            <div class="right">
              <!-- 今天 -->
              <template v-if="curDate == 0">
                <div v-if="getTimeRanges().length > 0">
                  <li v-for="(item, i) in getTimeRanges()" :key="i">
                    <el-radio v-model="form.time" :label="item">{{
                      item
                    }}</el-radio>
                  </li>
                </div>
                <div v-else>当日暂无预约时间段</div>
              </template>
              <template v-else>
                <li v-for="(item, i) in timeRange" :key="i">
                  <el-radio v-model="form.time" :label="item">{{
                    item
                  }}</el-radio>
                </li>
              </template>
            </div>
          </div>
        </el-form-item>
      </el-form>

      <span slot="footer">
        <el-button @click="visible = false" size="mini">取消</el-button>
        <el-button type="primary" @click="handleOk" size="mini">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { httpAction } from '@/api/manage';
import { getNowDateAndWeek } from '@/utils/util';

export default {
  components: {},
  props: {},
  data() {
    return {
      day: getNowDateAndWeek(new Date()).date,
      curDate: 0,
      days: [],
      timeRange: ['8:00-12:00', '14:00-18:00'],
      // timeRange: ['8:00-10:00', '10:00-12:00', '14:00-16:00', '16:00-18:00'],
      title: '操作',
      visible: false,
      confirmLoading: false,
      form: {
        day: getNowDateAndWeek(new Date()).date,
        time: null,
      },
      endDateOpt: {
        disabledDate: (time) => {
          // 日期选择限制
          let oneDay = 60 * 60 * 24 * 1000;
          return time.getTime() < Date.now() - oneDay;
        },
        // selectableRange 用来限制时分秒的选择，这里要求只能选择当前时间之后到0点的时间点
        // selectableRange: `${Date().split(' ')[4]} - 23:59:59`,
      },

      validatorRules: {
        name: [
          { required: true, message: '请输入姓名!' },
          {
            min: 2,
            max: 30,
            message: '长度在 2 到 30 个字符',
            trigger: 'blur',
          },
        ],
      },
      url: {
        edit: '/user/statistical/updateOrderTime',
      },
    };
  },
  watch: {},

  methods: {
    dayChange(val) {
      this.curDate = val;
      this.form.time = null;
    },
    getTimeRanges() {
      let range = ['8:00-12:00', '14:00-18:00'];
      // let nowtime = getNowDateAndWeek(new Date()).time;
      let nowtime = new Date(new Date()).getHours();
      if (nowtime >= 12 && nowtime < 18) {
        range = range.splice(1, 1);
      } else if (nowtime >= 18) {
        range = [];
      }
      // console.log(range.splice(1, 1));
      console.log(range);

      return range;
    },
    // getTimeRanges() {
    //   let range = ['8:00-10:00', '10:00-12:00', '14:00-16:00', '16:00-18:00'];
    //   // let nowtime = getNowDateAndWeek(new Date()).time;
    //   let nowtime = new Date(new Date()).getHours();
    //   // 8-10之间 下个节点
    //   //>18 暂无

    //   if (nowtime >= 8 && nowtime < 10) {
    //     range = range.splice(1, 3);
    //   } else if (nowtime >= 10 && nowtime < 14) {
    //     range = range.splice(2, 3);
    //   } else if (nowtime >= 14 && nowtime < 16) {
    //     range = range.splice(3, 3);
    //   } else if (nowtime >= 16) {
    //     range = [];
    //   }
    //   console.log(range);

    //   return range;
    // },
    getNowDateAndWeek,
    initDic() {
      let today = getNowDateAndWeek(new Date());

      this.days = [{ ...today }];
      for (let i = 1; i < 7; i++) {
        this.days[i] = getNowDateAndWeek(
          new Date(today.date).getTime() + 24 * 60 * 60 * 1000 * i
        );
      }
    },
    add() {
      this.edit({});
    },
    edit(record) {
      this.form = { ...record, ...this.form };
      this.curDate = 0;
      this.initDic();
      this.visible = true;
    },
    close() {
      this.$refs.form.resetFields();
      this.$emit('close');
      this.visible = false;
    },
    handleOk() {
      const that = this;
      // 触发表单验证
      // this.$refs.form.validate((valid) => {
      let valid = !!this.form.time;
      if (valid) {
        that.confirmLoading = true;
        let httpurl = this.url.edit;
        let method = 'post';
        let params = {
          orderId: this.form.orderId,
          appointmentTimeBegin:
            this.form.day + ` ${this.form.time.split('-')[0]}:00`,
          appointmentTimeEnd:
            this.form.day + ` ${this.form.time.split('-')[1]}:00`,
        };

        httpAction(httpurl, params, method)
          .then((res) => {
            if (res.code == 200) {
              that.$message.success('操作成功');
              that.$emit('ok');
            } else {
              that.$message.warning(res.msg);
            }
          })
          .finally(() => {
            that.confirmLoading = false;
            that.close();
          });
      } else {
        this.$message.warning('请选择时间');
      }
      // });
    },
  },
  created() {},
  mounted() {},
};
</script>
<style lang="scss" scoped>
.wrapper {
  .datePicker {
    width: 500px;
    display: flex;
    justify-content: flex-start;
    .right {
      margin-left: 100px;
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: center;
    }
  }
}
</style>
